module.exports = __webpack_public_path__ + "static/media/tanques-tanque-generico.cb3a6740.svg";